import StyledCardSkeleton from './styles';

const CardSkeleton = () => (
    <StyledCardSkeleton className="card-skeleton bordered" />
);

export default CardSkeleton;
